<template>
    <div class="container is-fluid reports">
        <nav class="level">
            <div class="level-left">
                <div class="level-item">
                    <b-field label="Fra">
                        <b-datepicker v-model="fromDate"
                            :first-day-of-week="1"
                            placeholder="Klikk for å velge..."
                            icon="calendar"
                            :date-formatter="formatDate"
                            :month-names="monthNames"
                            :day-names="dayNames"
                            >

                            <button class="button is-primary"
                                @click="date = new Date()">
                                <b-icon pack="fa" icon="calendar"></b-icon>
                                <span>I dag</span>
                            </button>

                        </b-datepicker>
                    </b-field>
                </div>
                <div class="level-item">
                    <b-field label="Til">
                        <b-datepicker v-model="toDate"
                            :first-day-of-week="1"
                            placeholder="Klikk for å velge..."
                            icon="calendar"
                            :date-formatter="formatDate"
                            :month-names="monthNames"
                            :day-names="dayNames"
                            >

                            <button class="button is-primary"
                                @click="date = new Date()">
                                <b-icon pack="fa" icon="calendar"></b-icon>
                                <span>I dag</span>
                            </button>

                        </b-datepicker>
                    </b-field>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                    <b-field label="Eksporter">
                        <a @click="getReportFile" class="button is-info">
                            
                            <b-icon icon="save"></b-icon>
                            <span>Last ned rapport</span>

                        </a>
                    </b-field>
                </div>
                
                <div class="level-item" v-if="isAdmin">
                    <b-field label="Vis rapport for (admin)">
                        <b-select placeholder="Velg firma" v-model="branch">
                            <option
                                v-for="option in customers"
                                :value="option.id"
                                :key="option.id">
                                {{ `${option.name} (${option.id})` }}
                            </option>
                        </b-select>
                    </b-field>
                </div>
                
            </div>
        </nav>

        <manual :viewSource="viewSource"></manual>
       
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Manual from '@/components/reports/Manual.vue'

export default {
    data () {
        return {
            monthNames: ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Desember'],
            dayNames: ['S', 'M', 'Ti', 'O', 'To', 'F', 'L'],
            viewSource: false
            
        }
    },
    components: {
        Manual
    },
    computed: {
        ...mapGetters('manualtransactions', ['data', 'loading', 'totals']),
        ...mapGetters('customers', ['customers']),
        ...mapGetters('auth', ['isAdmin']),
        fromDate: {
            get() {
                return this.$store.state.reports.from
            },
            set(value) {
                this.$store.dispatch('manualtransactions/setFromDate', value)
            }
        },
        toDate: {
            get() {
                return this.$store.state.reports.to
            },
            set(value) {
                this.$store.dispatch('manualtransactions/setToDate', value)
            }
        },
        branch: {
            get() {
                return this.$store.state.reports.branch
            },
            set (value) {
                this.$store.dispatch('manualtransactions/setBranch', value)
            }
        }
    },
    methods: {
        ...mapActions('manualtransactions', ['getReportData', 'getReportFile', 'setToDate', 'setFromDate']),
        ...mapActions('customers', ['getCustomers']),
        formatDate(date) {
            return this.$moment(date).format('D. MMM YYYY') // date.toLocaleDateString('nb-NO')
        } 
    },
    mounted () {
        // if (this.$route.query.from)
        //     this.setFromDate(this.$moment(this.$route.query.from).toDate())
        
        // if (this.$route.query.to)
        //     this.setToDate(this.$moment(this.$route.query.to).toDate())

        this.getReportData()
        this.getCustomers()
    },
    // beforeRouteUpdate (to) {
    //     console.log(JSON.stringify(to.params))
    //     this.$store.dispatch('reports/setReportType', to.params.reportType)
    // }
}
</script>

<style lang="scss" scoped>
div.reports {
    margin-top:32px;
    margin-left: 12px;
    margin-right: 12px;
}

#settings {
    div.dropdown-item {
        width: 425px !important;
    }
}
</style>
